import { formatDate } from 'libs/common';
import apiCall from './apiRequest';
import endPoints from './endpoints';
import config from 'config';

const { API } = config;

function filterRedemptionActivateFields(fields = {}) {
  const {
    country, region, city, zipCode
  } = fields;
  const _fields = {};

  if (country.value) {
    _fields.countryCode = country.value;
  }
  if (region.value) {
    _fields.stateCode = region.value;
  }
  if (city) {
    _fields.city = city;
  }
  if (zipCode) {
    _fields.zipCode = zipCode;
  }
  return _fields;
}

export function updateUserEmailApi(payload = {}) {
  return apiCall({
    method: 'put',
    url: `${API.fastApi}/${endPoints.me.profile.email}`,
    payload
  });
}

export function updateUserPasswordApi(payload = {}) {
  return apiCall({
    method: 'put',
    url: `${API.fastApi}/${endPoints.me.profile.password}`,
    payload
  });
}

export function deleteUserApi() {
  return apiCall({
    method: 'delete',
    url: `${API.fastApi}/${endPoints.me.default}`
  });
}

export function activateAccountUsingRedemption(token, userInfo) {
  const {
    activationCode,
  } = userInfo;

  const payload = filterRedemptionActivateFields(userInfo);

  return apiCall({
    method: 'post',
    url: `${API.fastApi}/${endPoints.me.redemption}/${activationCode}/activation`,
    token,
    payload
  });
}

export function activatePartner(token, userInfo) {
  const {
    activationCode,
  } = userInfo;

  return apiCall({
    method: 'post',
    url: `${API.fastApi}/${endPoints.me.redemption}/${activationCode}/activation`,
    token,
    payload: {}
  });
}

export function updateAdditionalInfoApi(userInfo = {}, token) {
  const { given_name, family_name, birthdate } = userInfo;

  return apiCall({
    method: 'put',
    url: `${API.fastApi}/${endPoints.me.profile.base}`,
    token,
    payload: {
      given_name,
      family_name,
      birthdate: birthdate && formatDate(birthdate, 'YYYY-MM-DD')
    }
  });
}

export function fetchUserBaseProfileApi() {
  return apiCall({
    method: 'get',
    url: `${API.fastApi}/${endPoints.me.profile.base}`
  });
}

export function fetchUserCommunicationPreferencesApi() {
  return apiCall({
    method: 'get',
    url: `${API.fastApi}/${endPoints.me.communicationPreferences}`
  });
}

export default {
  updateUserEmailApi,
  updateUserPasswordApi,
  deleteUserApi
};



// WEBPACK FOOTER //
// ./src/api/account.js